<template>
	<div class="mt-4">
		<b-modal ref="loaderModal"
			hide-footer
			title="Loading...">
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="valid_button">
			<button type="submit"
				class="btn btn-valid"
				@click.prevent="sendDatas">{{ $t("Button.validate") }}
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus.js";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidStepInfographic",
	components: {throbber, lottie_error},
	props: {
		id: Number,
		title: String,
		imageName: String,
		videoName: String,
	},
	data() {
		return {
			text_error: "",
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			this.$refs.loaderModal.show();

			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			if (this.title !== undefined) {
				bodyFormData.append("title", this.title);
			}
			if (this.imageName !== undefined) {
				bodyFormData.append("imageName", this.imageName);
			}
			if (this.videoName !== undefined) {
				bodyFormData.append("videoName", this.videoName);
			}
			axios.post(BASE_URL + "/public/api/stepInfographics/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				EventBus.$emit("isSaved", true);
				EventBus.$emit("setStepInfographicComplete", $this.id);
				EventBus.$emit("setModificationTitleLabel", "");
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
	},
};
</script>

<style scoped>
.btn-valid {
	border-radius: 5px;
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
</style>
